import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add framer-motion for animations
render(<App data-id="element-1390" />, document.getElementById('root'));